// Shared by ImagePreviewModal (Null) and NonNullEvidenceModal (Non-Null) --
// and by ReviewSubmitPanel, the review-submit UI both of them render. Kept
// as plain functions (not part of ReviewSubmitPanel itself) because each
// modal also uses them outside the panel -- e.g. to disable prev/next nav
// while an unsaved false-positive reason is pending, and to compute the
// per-occurrence progress label in the occurrence dropdown.

export function isIncompleteFalsePositive(cls) {
  return cls?.verdict === 'false_positive' && !String(cls?.fpReason || '').trim();
}

export const FP_REASON_REQUIRED = 'Enter a reason before you can save or move to another sample.';

/** Review progress over present (non-absent) samples only — matches "Show present only". */
export function getPresentReviewStats(classifications, evidenceList) {
  const cls = classifications || [];
  const list = evidenceList || [];
  let trueCount = 0;
  let fpCount = 0;
  let pending = 0;

  if (list.length === 0) {
    const actionable = cls.filter((s) => s?.verdict !== 'skipped');
    trueCount = actionable.filter((s) => s?.verdict === 'true_anomaly').length;
    fpCount = actionable.filter((s) => s?.verdict === 'false_positive').length;
    pending = actionable.length - trueCount - fpCount;
  } else {
    list.forEach((e, i) => {
      if ((e?.presence || '').toLowerCase() === 'absent') return;
      const v = cls[i]?.verdict;
      if (v === 'true_anomaly') trueCount += 1;
      else if (v === 'false_positive') fpCount += 1;
      else pending += 1;
    });
  }

  const total = trueCount + fpCount + pending;
  return { trueCount, fpCount, pending, total, reviewed: trueCount + fpCount };
}
